// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"42":"8498915a","853":"091a05c5"}[chunkId] + ".chunk.css";
};